// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CqDod","open":"styles_open__fqKUD","icon":"styles_icon__wb-jv","icon-search":"styles_icon-search__g6xik","iconSearch":"styles_icon-search__g6xik"};